import * as React from "react";
import { toast } from 'react-toastify';
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { GraduationCap, Video, FolderOpen } from "lucide-react";
import { format } from 'date-fns';


export const MOBILE_BREAKPOINT = 768;

export const certificationProgressList = [
  { id: 1, status: "ENROLLED", title: "Enrolled" },
  { id: 2, status: "TUTORIAL", title: "Tutorial" },
  { id: 3, status: "ASSIGNMENT", title: "Assignment" },
  { id: 4, status: "COMPLETED", title: "Completed" }
];

export const certificationAdminProgressList = [
  { id: 1, status: "ENROLLED", title: "Enrolled" },
  { id: 2, status: "TUTORIAL", title: "Tutorial" },
  { id: 3, status: "ASSIGNMENT", title: "Assignment" },
  { id: 4, status: "COMPLETED", title: "Completed" },
  { id: 5, status: "CERTIFIED", title: "Certified" },
  { id: 6, status: "REJECTED", title: "Rejected" }
];

export const certificationAdminProgressListForFilter = [
  { id: 1, status: "ALL", title: "All" },
  { id: 2, status: "ENROLLED", title: "Enrolled" },
  { id: 3, status: "TUTORIAL", title: "Tutorial" },
  { id: 4, status: "ASSIGNMENT", title: "Assignment" },
  { id: 5, status: "COMPLETED", title: "Completed" },
  { id: 6, status: "CERTIFIED", title: "Certified" },
  { id: 7, status: "REJECTED", title: "Rejected" }
];

export const getStatusColor = (status) => {
  switch (status) {
    case 'ENROLLED': return 'bg-muted text-muted-foreground';
    case 'TUTORIAL': return 'bg-cyan-500 text-white';
    case 'ASSIGNMENT': return 'bg-indigo-500 text-white';
    case 'COMPLETED': return 'bg-blue-500 text-white';
    case 'CERTIFIED': return 'bg-success text-white';
    case 'REJECTED': return 'bg-warning text-white';
    default: return 'bg-muted text-muted-foreground';
  }
};

export const resistrationStatusList = [
  { id: 1, status: "ALL", title: "All" },
  { id: 2, status: "PENDING", title: "Pending" },
  { id: 3, status: "APPROVED", title: "Approved" },
  { id: 4, status: "REJECTED", title: "Rejected" },
]

export const quickActions = [
  { title: "Add New Certificate", href: "/CreateCertificate", icon: GraduationCap },
  { title: "Add New Module", href: "/CreatedModule", icon: FolderOpen },
  { title: "Add New Chapter", href: "/CreateChapter", icon: Video },
];

export const dashboardData = [
  { title: "Total Certificates", count: '', icon: GraduationCap, href: "/Certifications" },
  { title: "Total Modules", count: '', icon: FolderOpen, href: "/Modules" },
  { title: "Total Chapters", count: '', icon: Video, href: "/Chapters" },
]

export const certificateTypes = [
  { id: 1, name: "Web", value: "WEB" },
  { id: 2, name: "Mobile", value: "MOBILE" },
  { id: 3, name: "DevOps", value: "DEVOPS" },
  { id: 4, name: "DesignSystem", value: "DESIGNSYSTEM" },
  { id: 5, name: "Overview", value: "OVERVIEW" },

]

export const legendlist = [
  { id: 1, title: 'Available', className: 'bg-primary' },
  { id: 2, title: 'Unavailable', className: 'bg-muted' },
  { id: 3, title: 'Booked', className: 'bg-success' },
  { id: 4, title: 'Booking cancellations', className: 'bg-red-950' },
  { id: 5, title: 'Cancelled', className: 'bg-red-600' }
]

export const menteeLegendlist = [
  { id: 1, title: 'Available', className: 'bg-white border border-input' },
  { id: 2, title: 'Booked', className: 'bg-success' },
  { id: 3, title: 'Cancelled', className: 'bg-red-950' }
]

export const certificateInfo = [
  { id: 1, key: 'name', value: 'developerName', isdate: false, isStatic: false },
  { id: 2, key: 'email', value: 'developerEmail', isdate: false, isStatic: false },
  { id: 3, key: 'mentorName', value: 'mentorName', isdate: false, isStatic: false },
  { id: 4, key: 'certificateName', value: 'certificationTitle', isdate: false, isStatic: false },
  { id: 5, key: 'certifiedOn', value: 'issuedAt', isdate: true, isStatic: false },
  { id: 6, key: 'certificationDate', value: 'completedAt', isdate: true, isStatic: false },
  { id: 7, key: 'certificationID', value: 'certificationCode', isdate: false, isStatic: false },
  { id: 8, key: 'certifiedBy', value: 'WaveMaker', isdate: false, isStatic: true }
]
export const isValidNameOrLastname = (input) => {
  // Simple name or lastname regex format check
  const regex = /^[a-zA-Z\s]+$/;
  return regex.test(input);
};

export const isValidEmailAddressFormat = (input) => {
  // simple email address format check
  const regex = /^\S+@\S+\.\S+$/;
  return regex.test(input);
};

export const isValidCardNumber = (input) => {
  // Remove all non-digit characters
  const cleanedInput = input.replace(/[^0-9]/g, "");
  // test for credit card number between 13 and 19 characters
  const regex = /^\d{13,19}$/;
  return regex.test(cleanedInput);
}

export const isValidCreditCardExpirationDate = (input) => {
  // simple expiration date format check
  const regex = /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
  return regex.test(input);
};

export const isValidCreditCardCVVOrCVC = (input) => {
  // simple CVV or CVC format check
  const regex = /^[0-9]{3,4}$/;
  return regex.test(input);
};

export const priceFormat = new Intl.NumberFormat("en-US", {
  currency: 'USD',
  style: 'currency'
})

export const startLandingPageAnimation = () => {
  const container = document.querySelector('.hero');

  // Anchors (original background-position in %)
  const anchors = [
    { baseX: 80, baseY: 20 },
    { baseX: 14, baseY: 84 },
    { baseX: 90, baseY: 85 }
  ];

  // Rectangle movement size
  const movementBox = { width: 200, height: 100 }; // ← Updated here

  // Store offsets + targets
  let icons = anchors.map(anchor => ({
    anchor,
    offsetX: 0,
    offsetY: 0,
    targetX: Math.random() * movementBox.width - movementBox.width / 2,
    targetY: Math.random() * movementBox.height - movementBox.height / 2
  }));

  function animate() {
    if (container) {
      const rect = container.getBoundingClientRect();
      const cw = rect.width;
      const ch = rect.height;

      const easing = 0.02; // slower movement

      const positions = icons.map(icon => {
        // Easing movement
        icon.offsetX += (icon.targetX - icon.offsetX) * easing;
        icon.offsetY += (icon.targetY - icon.offsetY) * easing;

        // Micro jitter
        const jitterX = (Math.random() - 0.5) * 2;
        const jitterY = (Math.random() - 0.5) * 2;

        const finalOffsetX = icon.offsetX + jitterX;
        const finalOffsetY = icon.offsetY + jitterY;

        // Near enough → get new target
        if (
          Math.abs(icon.targetX - icon.offsetX) < 1 &&
          Math.abs(icon.targetY - icon.offsetY) < 1
        ) {
          icon.targetX = Math.random() * movementBox.width - movementBox.width / 2;
          icon.targetY = Math.random() * movementBox.height - movementBox.height / 2;
        }

        // Base anchor in px
        const baseXpx = (icon.anchor.baseX / 100) * cw;
        const baseYpx = (icon.anchor.baseY / 100) * ch;

        const finalXpx = baseXpx + finalOffsetX;
        const finalYpx = baseYpx + finalOffsetY;

        // Convert to background-position %
        const xPercent = (finalXpx / cw) * 100;
        const yPercent = (finalYpx / ch) * 100;

        return `${xPercent.toFixed(2)}% ${yPercent.toFixed(2)}%`;
      });

      container.style.backgroundPosition = positions.join(', ');
      requestAnimationFrame(animate);
    }
  }
  animate();
}

export const startAccordianAnimation = () => {
  const wrappers = document.querySelectorAll('.accordion-wrapper');
  const allHeaders = [];
  wrappers.forEach(list => {
    const headers = list.querySelectorAll('.accordion-header');
    allHeaders.push(...headers);

    headers.forEach(header => {
      const onClick = () => {
        const body = header.nextElementSibling;
        const item = header.parentElement;
        const isOpen = item.classList.contains('active');

        // Collapse all in this group
        list.querySelectorAll('.accordion-body').forEach(section => {
          section.style.height = '0px';
          section.parentElement.classList.remove('active');
        });

        if (!isOpen) {
          body.style.height = 'auto';
          const fullHeight = body.scrollHeight + 'px';
          body.style.height = '0px';
          void body.offsetWidth;
          body.style.height = fullHeight;
          item.classList.add('active');
        }
      };

      header.addEventListener('click', onClick);

      // Save to remove later
      header._accordionClickHandler = onClick;
    });

    // Expand first item by default
    const firstHeader = list.querySelector('.accordion-header');
    if (firstHeader) firstHeader.click();
  });

  // Animation logic (if needed)
  const pos = [
    { x: 0, y: 0, dx: 0.5, dy: 0.4 },
    { x: 20, y: 30, dx: -0.3, dy: 0.5 },
    { x: 50, y: 80, dx: 0.4, dy: -0.6 }
  ];
  const bounds = { width: 250, height: 250 };

  function animate() {
    pos.forEach(p => {
      p.x += p.dx;
      p.y += p.dy;
      if (p.x < 0 || p.x > bounds.width - 20) p.dx *= -1;
      if (p.y < 0 || p.y > bounds.height - 20) p.dy *= -1;
    });

    const posString = pos.map(p => `${p.x}px ${p.y}px`).join(', ');
    requestAnimationFrame(animate);
  }

  animate();
  return () => {
    allHeaders.forEach(header => {
      header.removeEventListener('click', header._accordionClickHandler);
    });
  };
}


export const formatDuration = (minutes) => {
  if (minutes <= 0 || isNaN(minutes)) return "0 mins";

  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;

  if (hrs > 0 && mins > 0) {
    return `${hrs} hr${hrs > 1 ? "s" : ""} ${mins} min${mins > 1 ? "s" : ""}`;
  } else if (hrs > 0) {
    return `${hrs} hr${hrs > 1 ? "s" : ""}`;
  } else {
    return `${mins} min${mins > 1 ? "s" : ""}`;
  }
}

export const scrollToSpecificElement = (elementIDOrClass, type) => {
  if (type === 'id') {
    document.getElementById(elementIDOrClass).scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
  else if (type === 'class') {
    const elements = document.querySelectorAll(elementIDOrClass);
    if (elements[0]) {
      elements[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
}
export const S3_BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME || 'https://wm-ps-igniters.s3.amazonaws.com/Academy/';
export const initiateToast = (message, type, verticalPostion, horizontalPosition) => {
  let toastConfig = {
    position: 'bottom-right',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };
  if (verticalPostion && horizontalPosition) {
    toastConfig = {
      ...toastConfig,
      position: `${verticalPostion}-${horizontalPosition}`
    }
  }
  if (type === 'success') {
    toast.success(message, toastConfig);
  } else if (type === 'error') {
    toast.error(message, toastConfig);
  }
  else if (type === 'info') {
    toast.info(message, toastConfig);
  } else if (type === 'warning') {
    toast.warn(message, toastConfig);
  }
}
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const CustomNotification = ({ closeToast, message }) => {
  return (
    <div className="flex flex-col space-y-3">
      {/* Message */}
      <p className="text-gray-800 font-medium">{message}</p>

      {/* Buttons */}
      <div className="flex gap-3">
        <button
          className="px-4 py-1 bg-red-600 text-white rounded hover:bg-red-700"
          onClick={() => closeToast("Yes")}
        >
          Yes
        </button>
        <button
          className="px-4 py-1 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          onClick={() => closeToast("No")}
        >
          No
        </button>
      </div>
    </div>
  )
}

export const initiateCustomToast = (message, yesFun, value) => {
  toast(
    ({ closeToast }) => (
      <CustomNotification closeToast={closeToast} message={message} />
    ),
    {
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      position: "bottom-right",
      onClose(reason) {
        switch (reason) {
          case "Yes":
            yesFun(value);
            break;
          case "No":
            break;
          default:
            break;
        }
      },
    }
  );
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(undefined)
  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

export const formatDate = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    // Day with suffix (st, nd, rd, th)
    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();
    return `${day}${suffix} ${month} ${year}`;
  }
}

export const getInitials = (name) => {
  if (!name) return "";

  return name
    .split(" ")                // split into words
    .map(word => word[0])      // take first letter
    .join("")                  // join together
    .toUpperCase();            // uppercase
}

export const capitalizeWords = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
}

export const addTimes = (time1, time2) => {
  // Split into hours and minutes
  const [h1, m1] = time1.split(':').map(Number);
  const [h2, m2] = time2.split(':').map(Number);

  // Convert both to total minutes
  const totalMinutes = h1 * 60 + m1 + h2 * 60 + m2;

  // Convert back to hours and minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Format back to HH:MM
  const formatted =
    String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');

  return formatted;
}

export const shortDateFormat = (date) => {
  const finalDate = new Date(date);
  const year = finalDate.getFullYear();
  const month = String(finalDate.getMonth() + 1).padStart(2, '0');
  const day = String(finalDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const isSameDay = (a, b) => {
  const d1 = new Date(a);
  const d2 = new Date(b);
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return d1.getTime() === d2.getTime();
};

export const getCurrentWeekFridayDate = () => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // Sunday=0, Monday=1, ..., Friday=5, Saturday=6
  // Calculate how many days to add to reach Friday (5)
  const daysUntilFriday = (5 - dayOfWeek + 7) % 7; // ensures correct wrap for weekends
  const friday = new Date(today);
  friday.setDate(today.getDate() + daysUntilFriday);
  return format(friday, "yyyy-MM-dd");
}

export const getDateOfCurrentWeek = (weekday) => {
  const today = new Date();
  let day = today.getDay(); // 0 = Sun, 1 = Mon ... 6 = Sat

  // Convert Sunday (0) to 7 for ISO week
  day = day === 0 ? 7 : day;

  // Clone date
  const result = new Date(today);

  // weekday (1-7): Monday to Sunday
  result.setDate(today.getDate() - (day - weekday));
  return result;
}

export const isDateInCurrentWeekRange = (date, startDate, endDate) => {
  const d = new Date(date).setHours(0, 0, 0, 0);
  const s = new Date(startDate).setHours(0, 0, 0, 0);
  const e = new Date(endDate).setHours(0, 0, 0, 0);

  return d >= s && d <= e;
}

export const getDateOfWeekday = (startDate, dayOfWeek) => {
  const result = new Date(startDate);
  const currentWeekday = result.getDay(); // Monday = 1

  // Find how many days to add to reach the target weekday
  const diff = dayOfWeek - currentWeekday;

  result.setDate(result.getDate() + diff);

  return result;
}


export const timeAgo = (date) => {
  const seconds = Math.floor((Date.now() - new Date(date)) / 1000);
  const intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "week", seconds: 604800 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
  ];

  for (const interval of intervals) {
    const count = Math.floor(seconds / interval.seconds);
    if (count >= 1) {
      return `${count} ${interval.label}${count > 1 ? "s" : ""} ago`;
    }
  }

  return "just now";
}
export const formatText = (text = "") => {
  return text
    .replace(/\s+/g, "")
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
}